import { booleanAttribute, ChangeDetectionStrategy, Component, effect, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Study } from '../study.service';

/**
 * Studies related user input.
 */
@Component({
  selector: 'app-studies',
  templateUrl: './studies.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule]
})
export class StudiesComponent {
  /**
  * Available studies list.
  */
  public studies = input.required({
    transform: (value: Study[] | undefined) => value ?? []
  });

  /**
   * Selected study.
   */
  public study = model<Study>();

  /**
   * Specifies if component is disabled.
   */
  public disabled = input(false, { transform: booleanAttribute });

  constructor() {
    effect(() => {
      const studies = this.studies();
      if (studies?.length > 0)
        this.study.set(studies[0]);
    });
  }
}
